window.slate = window.slate || {};
window.theme = window.theme || {};

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = false;
window.lazySizesConfig.loadMode = 3;
window.lazySizesConfig.expand = 1000;


/*================ Require ================*/
(function (a) {
  var r = a.fn.domManip,
    d = "_tmplitem",
    q = /^[^<]*(<[\w\W]+>)[^>]*$|\{\{\! /,
    b = {},
    f = {},
    e,
    p = { key: 0, data: {} },
    h = 0,
    c = 0,
    l = [];
  function g(e, d, g, i) {
    var c = {
      data: i || (d ? d.data : {}),
      _wrap: d ? d._wrap : null,
      tmpl: null,
      parent: d || null,
      nodes: [],
      calls: u,
      nest: w,
      wrap: x,
      html: v,
      update: t,
    };
    e && a.extend(c, e, { nodes: [], parent: d });
    if (g) {
      c.tmpl = g;
      c._ctnt = c._ctnt || c.tmpl(a, c);
      c.key = ++h;
      (l.length ? f : b)[h] = c;
    }
    return c;
  }
  a.each(
    {
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith",
    },
    function (f, d) {
      a.fn[f] = function (n) {
        var g = [],
          i = a(n),
          k,
          h,
          m,
          l,
          j = this.length === 1 && this[0].parentNode;
        e = b || {};
        if (
          j &&
          j.nodeType === 11 &&
          j.childNodes.length === 1 &&
          i.length === 1
        ) {
          i[d](this[0]);
          g = this;
        } else {
          for (h = 0, m = i.length; h < m; h++) {
            c = h;
            k = (h > 0 ? this.clone(true) : this).get();
            a.fn[d].apply(a(i[h]), k);
            g = g.concat(k);
          }
          c = 0;
          g = this.pushStack(g, f, i.selector);
        }
        l = e;
        e = null;
        a.tmpl.complete(l);
        return g;
      };
    }
  );
  a.fn.extend({
    tmpl: function (d, c, b) {
      return a.tmpl(this[0], d, c, b);
    },
    tmplItem: function () {
      return a.tmplItem(this[0]);
    },
    template: function (b) {
      return a.template(b, this[0]);
    },
    domManip: function (d, l, j) {
      if (d[0] && d[0].nodeType) {
        var f = a.makeArray(arguments),
          g = d.length,
          i = 0,
          h;
        while (i < g && !(h = a.data(d[i++], "tmplItem")));
        if (g > 1) f[0] = [a.makeArray(d)];
        if (h && c)
          f[2] = function (b) {
            a.tmpl.afterManip(this, b, j);
          };
        r.apply(this, f);
      } else r.apply(this, arguments);
      c = 0;
      !e && a.tmpl.complete(b);
      return this;
    },
  });
  a.extend({
    tmpl: function (d, h, e, c) {
      var j,
        k = !c;
      if (k) {
        c = p;
        d = a.template[d] || a.template(null, d);
        f = {};
      } else if (!d) {
        d = c.tmpl;
        b[c.key] = c;
        c.nodes = [];
        c.wrapped && n(c, c.wrapped);
        return a(i(c, null, c.tmpl(a, c)));
      }
      if (!d) return [];
      if (typeof h === "function") h = h.call(c || {});
      e && e.wrapped && n(e, e.wrapped);
      j = a.isArray(h)
        ? a.map(h, function (a) {
            return a ? g(e, c, d, a) : null;
          })
        : [g(e, c, d, h)];
      return k ? a(i(c, null, j)) : j;
    },
    tmplItem: function (b) {
      var c;
      if (b instanceof a) b = b[0];
      while (
        b &&
        b.nodeType === 1 &&
        !(c = a.data(b, "tmplItem")) &&
        (b = b.parentNode)
      );
      return c || p;
    },
    template: function (c, b) {
      if (b) {
        if (typeof b === "string") b = o(b);
        else if (b instanceof a) b = b[0] || {};
        if (b.nodeType)
          b = a.data(b, "tmpl") || a.data(b, "tmpl", o(b.innerHTML));
        return typeof c === "string" ? (a.template[c] = b) : b;
      }
      return c
        ? typeof c !== "string"
          ? a.template(null, c)
          : a.template[c] || a.template(null, q.test(c) ? c : a(c))
        : null;
    },
    encode: function (a) {
      return ("" + a)
        .split("<")
        .join("&lt;")
        .split(">")
        .join("&gt;")
        .split('"')
        .join("&#34;")
        .split("'")
        .join("&#39;");
    },
  });
  a.extend(a.tmpl, {
    tag: {
      tmpl: {
        _default: { $2: "null" },
        open: "if($notnull_1){_=_.concat($item.nest($1,$2));}",
      },
      wrap: {
        _default: { $2: "null" },
        open: "$item.calls(_,$1,$2);_=[];",
        close: "call=$item.calls();_=call._.concat($item.wrap(call,_));",
      },
      each: {
        _default: { $2: "$index, $value" },
        open: "if($notnull_1){$.each($1a,function($2){with(this){",
        close: "}});}",
      },
      if: { open: "if(($notnull_1) && $1a){", close: "}" },
      else: {
        _default: { $1: "true" },
        open: "}else if(($notnull_1) && $1a){",
      },
      html: { open: "if($notnull_1){_.push($1a);}" },
      "=": {
        _default: { $1: "$data" },
        open: "if($notnull_1){_.push($.encode($1a));}",
      },
      "!": { open: "" },
    },
    complete: function () {
      b = {};
    },
    afterManip: function (f, b, d) {
      var e =
        b.nodeType === 11
          ? a.makeArray(b.childNodes)
          : b.nodeType === 1
          ? [b]
          : [];
      d.call(f, b);
      m(e);
      c++;
    },
  });
  function i(e, g, f) {
    var b,
      c = f
        ? a.map(f, function (a) {
            return typeof a === "string"
              ? e.key
                ? a.replace(
                    /(<\w+)(?=[\s>])(?![^>]*_tmplitem)([^>]*)/g,
                    "$1 " + d + '="' + e.key + '" $2'
                  )
                : a
              : i(a, e, a._ctnt);
          })
        : e;
    if (g) return c;
    c = c.join("");
    c.replace(
      /^\s*([^<\s][^<]*)?(<[\w\W]+>)([^>]*[^>\s])?\s*$/,
      function (f, c, e, d) {
        b = a(e).get();
        m(b);
        if (c) b = j(c).concat(b);
        if (d) b = b.concat(j(d));
      }
    );
    return b ? b : j(c);
  }
  function j(c) {
    var b = document.createElement("div");
    b.innerHTML = c;
    return a.makeArray(b.childNodes);
  }
  function o(b) {
    return new Function(
      "jQuery",
      "$item",
      "var $=jQuery,call,_=[],$data=$item.data;with($data){_.push('" +
        a
          .trim(b)
          .replace(/([\\'])/g, "\\$1")
          .replace(/[\r\t\n]/g, " ")
          .replace(/\$\{([^\}]*)\}/g, "{{= $1}}")
          .replace(
            /\{\{(\/?)(\w+|.)(?:\(((?:[^\}]|\}(?!\}))*?)?\))?(?:\s+(.*?)?)?(\(((?:[^\}]|\}(?!\}))*?)\))?\s*\}\}/g,
            function (m, l, j, d, b, c, e) {
              var i = a.tmpl.tag[j],
                h,
                f,
                g;
              if (!i) throw "Template command not found: " + j;
              h = i._default || [];
              if (c && !/\w$/.test(b)) {
                b += c;
                c = "";
              }
              if (b) {
                b = k(b);
                e = e ? "," + k(e) + ")" : c ? ")" : "";
                f = c
                  ? b.indexOf(".") > -1
                    ? b + c
                    : "(" + b + ").call($item" + e
                  : b;
                g = c
                  ? f
                  : "(typeof(" +
                    b +
                    ")==='function'?(" +
                    b +
                    ").call($item):(" +
                    b +
                    "))";
              } else g = f = h.$1 || "null";
              d = k(d);
              return (
                "');" +
                i[l ? "close" : "open"]
                  .split("$notnull_1")
                  .join(
                    b
                      ? "typeof(" + b + ")!=='undefined' && (" + b + ")!=null"
                      : "true"
                  )
                  .split("$1a")
                  .join(g)
                  .split("$1")
                  .join(f)
                  .split("$2")
                  .join(
                    d
                      ? d.replace(
                          /\s*([^\(]+)\s*(\((.*?)\))?/g,
                          function (d, c, b, a) {
                            a = a ? "," + a + ")" : b ? ")" : "";
                            return a ? "(" + c + ").call($item" + a : d;
                          }
                        )
                      : h.$2 || ""
                  ) +
                "_.push('"
              );
            }
          ) +
        "');}return _;"
    );
  }
  function n(c, b) {
    c._wrap = i(c, true, a.isArray(b) ? b : [q.test(b) ? b : a(b).html()]).join(
      ""
    );
  }
  function k(a) {
    return a ? a.replace(/\\'/g, "'").replace(/\\\\/g, "\\") : null;
  }
  function s(b) {
    var a = document.createElement("div");
    a.appendChild(b.cloneNode(true));
    return a.innerHTML;
  }
  function m(o) {
    var n = "_" + c,
      k,
      j,
      l = {},
      e,
      p,
      i;
    for (e = 0, p = o.length; e < p; e++) {
      if ((k = o[e]).nodeType !== 1) continue;
      j = k.getElementsByTagName("*");
      for (i = j.length - 1; i >= 0; i--) m(j[i]);
      m(k);
    }
    function m(j) {
      var p,
        i = j,
        k,
        e,
        m;
      if ((m = j.getAttribute(d))) {
        while (
          i.parentNode &&
          (i = i.parentNode).nodeType === 1 &&
          !(p = i.getAttribute(d))
        );
        if (p !== m) {
          i = i.parentNode
            ? i.nodeType === 11
              ? 0
              : i.getAttribute(d) || 0
            : 0;
          if (!(e = b[m])) {
            e = f[m];
            e = g(e, b[i] || f[i], null, true);
            e.key = ++h;
            b[h] = e;
          }
          c && o(m);
        }
        j.removeAttribute(d);
      } else if (c && (e = a.data(j, "tmplItem"))) {
        o(e.key);
        b[e.key] = e;
        i = a.data(j.parentNode, "tmplItem");
        i = i ? i.key : 0;
      }
      if (e) {
        k = e;
        while (k && k.key != i) {
          k.nodes.push(j);
          k = k.parent;
        }
        delete e._ctnt;
        delete e._wrap;
        a.data(j, "tmplItem", e);
      }
      function o(a) {
        a = a + n;
        e = l[a] = l[a] || g(e, b[e.parent.key + n] || e.parent, null, true);
      }
    }
  }
  function u(a, d, c, b) {
    if (!a) return l.pop();
    l.push({ _: a, tmpl: d, item: this, data: c, options: b });
  }
  function w(d, c, b) {
    return a.tmpl(a.template(d), c, b, this);
  }
  function x(b, d) {
    var c = b.options || {};
    c.wrapped = d;
    return a.tmpl(a.template(b.tmpl), b.data, c, b.item);
  }
  function v(d, c) {
    var b = this._wrap;
    return a.map(
      a(a.isArray(b) ? b.join("") : b).filter(d || "*"),
      function (a) {
        return c ? a.innerText || a.textContent : a.outerHTML || s(a);
      }
    );
  }
  function t() {
    var b = this.nodes;
    a.tmpl(null, null, null, this).insertBefore(b[0]);
    a(b).remove();
  }
})(jQuery);

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Market-aware:
 * The recently-viewed list is stored in a cookie that is namespaced by the
 * current Shopify market (e.g. us / ca / eu) but is NOT namespaced by language
 * (en / fr / es). This means:
 *   - Switching language within a market keeps the same list.
 *   - Products that only exist in one market never leak into another market's
 *     list (which previously happened and relied on failed AJAX fetches to
 *     self-heal).
 *
 * Consent:
 * The list is a functionality cookie (Shopify's "preferences" purpose,
 * Consentmo's Functionality choice). It is read and written only while
 * window.CodeageConsent (snippets/consent-gate.liquid) reports preferences as
 * allowed. Calls made before that wait for it, so an Accept later on the same
 * page still records and shows the list. While preferences are not allowed,
 * every shopify_recently_viewed cookie is deleted. Without the consent gate,
 * nothing is stored.
 */

Shopify.Products = (function () {
  var config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 10,
    wrapperId: "recently-viewed-products",
    templateId: "recently-viewed-product-template",
    onComplete: null,
    // Current market handle.
    // Preferred: inject it from Liquid at the call site, e.g.
    //   Shopify.Products.recordRecentlyViewed({ market: {{ localization.market.handle | json }} });
    // If left null, we fall back to window.Shopify.market, then to the
    // shopping country exposed on window.Shopify.country.
    market: null,
  };

  var productHandleQueue = [];
  var wrapper = null;
  var template = null;

  // Resolve the current market so the cookie can be namespaced by it.
  // Language is intentionally excluded: the list is shared across languages
  // inside the same market.
  var getMarket = function () {
    var market =
      config.market ||
      (window.Shopify && window.Shopify.market) ||
      "";

    // Fallback only used if no market handle was provided anywhere.
    // US and CA are their own markets; everything else maps to EU.
    if (!market && window.Shopify && window.Shopify.country) {
      switch (String(window.Shopify.country).toUpperCase()) {
        case "US":
          market = "us";
          break;
        case "CA":
          market = "ca";
          break;
        default:
          market = "eu";
      }
    }

    return String(market || "default").toLowerCase();
  };

  var cookie = {
    configuration: {
      expires: 90,
      path: "/",
      domain: window.location.hostname,
    },
    baseName: "shopify_recently_viewed",
    // The actual cookie name is resolved per call so it always reflects the
    // market that is active at read/write time.
    name: function () {
      return this.baseName + "_" + getMarket();
    },
    write: function (recentlyViewed) {
      jQuery.cookie(this.name(), recentlyViewed.join(" "), this.configuration);
    },
    read: function () {
      var recentlyViewed = [];
      var cookieValue = jQuery.cookie(this.name());
      var currentProduct = $("#template-product").data("product-handle");

      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(" ");
      }

      // Remove current product from the array
      if (recentlyViewed.indexOf(currentProduct) != -1) {
        var currentProductIndex = recentlyViewed.indexOf(currentProduct);
        recentlyViewed.splice(currentProductIndex, 1);
      }

      return recentlyViewed;
    },
    // The cookie plugin sets expires on the options it is given, so deletes
    // get a copy and later writes keep their 90 days.
    destroy: function () {
      jQuery.cookie(this.name(), null, jQuery.extend({}, this.configuration));
    },
    // Every market's list and the older unsuffixed one, whether it was set
    // for this host as the domain or as a host-only cookie.
    destroyAll: function () {
      var cookies = document.cookie ? document.cookie.split(";") : [];
      for (var i = 0; i < cookies.length; i++) {
        var name = jQuery.trim(cookies[i].split("=")[0]);
        if (name.indexOf(this.baseName) !== 0) continue;
        jQuery.cookie(name, null, jQuery.extend({}, this.configuration));
        jQuery.cookie(name, null, { path: this.configuration.path });
      }
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    },
  };

  var finalize = function () {
    wrapper.show();
    // If we have a callback.
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {}
    }
  };

  var moveAlong = function (shown) {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      jQuery.ajax({
        dataType: "html",
        url: window.routes.root_url + "/products/" + productHandleQueue[0] + "?view=recently-viewed",
        cache: false,
        success: function (product) {
          try{
            const productJson = JSON.parse(product);
            template.tmpl(productJson).appendTo(wrapper);
          }catch(error){
            cookie.remove(productHandleQueue[0]);
          }finally{
            productHandleQueue.shift();
            shown++;
            moveAlong(shown);
          }
          
          
        },
        error: function () {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong(shown);
        },
      });
    } else {
      finalize();
    }
  };

  var preferencesAllowed = false;
  var waitingForConsent = [];

  // Runs fn now if preferences are allowed, otherwise once they are.
  var whenAllowed = function (fn) {
    if (preferencesAllowed) {
      fn();
    } else {
      waitingForConsent.push(fn);
    }
  };

  if (window.CodeageConsent && typeof window.CodeageConsent.watch === "function") {
    window.CodeageConsent.watch("preferences", function (allowed) {
      preferencesAllowed = allowed;
      if (!allowed) {
        cookie.destroyAll();
        return;
      }
      var ready = waitingForConsent;
      waitingForConsent = [];
      for (var i = 0; i < ready.length; i++) {
        ready[i]();
      }
    });
  }

  return {
    showRecentlyViewed: function (params) {
      whenAllowed(function () {
        var settings = params || {};
        var shown = 0;

        // Update defaults.
        jQuery.extend(config, settings);

        // Read cookie.
        productHandleQueue = cookie.read();

        // Template and element where to insert.
        template = jQuery("#" + config.templateId);
        wrapper = jQuery("#" + config.wrapperId);

        // How many products to show.
        config.howManyToShow = Math.min(
          productHandleQueue.length,
          config.howManyToShow
        );

        // If we have any to show.
        if (config.howManyToShow && template.length && wrapper.length) {
          // Getting each product with an Ajax call and rendering it on the page.
          moveAlong(shown);
        }
      });
    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    // Empty until preferences are allowed. Use withList to wait for them.
    getList: function () {
      return preferencesAllowed ? cookie.read() : [];
    },

    // Calls back with the list once preferences are allowed, never otherwise.
    withList: function (callback) {
      whenAllowed(function () {
        callback(cookie.read());
      });
    },

    recordRecentlyViewed: function (params) {
      whenAllowed(function () {
        // Update defaults.
        jQuery.extend(config, params || {});

        // Read cookie.
        var recentlyViewed = cookie.read();

        // If we are on a product page.
        if (window.location.pathname.indexOf("/products/") !== -1) {
          // What is the product handle on this page.
          var productHandle = window.location.pathname.match(
            /\/products\/([a-z0-9\-]+)/
          )[1];
          // In what position is that product in memory.
          var position = jQuery.inArray(productHandle, recentlyViewed);
          // If not in memory.
          if (position === -1) {
            // Add product at the start of the list.
            recentlyViewed.unshift(productHandle);
            // Only keep what we need.
            recentlyViewed = recentlyViewed.splice(
              0,
              config.howManyToStoreInMemory
            );
          } else {
            // Remove the product and place it at start of list.
            recentlyViewed.splice(position, 1);
            recentlyViewed.unshift(productHandle);
          }

          // Update cookie.
          cookie.write(recentlyViewed);
        }
      });
    },
  };
})();

/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) {
  if (typeof j != "undefined") {
    m = m || {};
    if (j === null) {
      j = "";
      m.expires = -1;
    }
    var e = "";
    if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
      var f;
      if (typeof m.expires == "number") {
        f = new Date();
        f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
      } else {
        f = m.expires;
      }
      e = "; expires=" + f.toUTCString();
    }
    var l = m.path ? "; path=" + m.path : "";
    var g = m.domain ? "; domain=" + m.domain : "";
    var a = m.secure ? "; secure" : "";
    document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("");
  } else {
    var d = null;
    if (document.cookie && document.cookie != "") {
      var k = document.cookie.split(";");
      for (var h = 0; h < k.length; h++) {
        var c = jQuery.trim(k[h]);
        if (c.substring(0, b.length + 1) == b + "=") {
          d = decodeURIComponent(c.substring(b.length + 1));
          break;
        }
      }
    }
    return d;
  }
};

/*!
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery throttle / debounce: Sometimes, less is more!
//
// *Version: 1.1, Last updated: 3/7/2010*
//
// Project Home - http://benalman.com/projects/jquery-throttle-debounce-plugin/
// GitHub       - http://github.com/cowboy/jquery-throttle-debounce/
// Source       - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.js
// (Minified)   - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.min.js (0.7kb)
//
// About: License
//
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
//
// About: Examples
//
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
//
// Throttle - http://benalman.com/code/projects/jquery-throttle-debounce/examples/throttle/
// Debounce - http://benalman.com/code/projects/jquery-throttle-debounce/examples/debounce/
//
// About: Support and Testing
//
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
//
// jQuery Versions - none, 1.3.2, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-throttle-debounce/unit/
//
// About: Release History
//
// 1.1 - (3/7/2010) Fixed a bug in <jQuery.throttle> where trailing callbacks
//       executed later than they should. Reworked a fair amount of internal
//       logic as well.
// 1.0 - (3/6/2010) Initial release as a stand-alone project. Migrated over
//       from jquery-misc repo v0.4 to jquery-throttle repo v1.0, added the
//       no_trailing throttle parameter and debounce functionality.
//
// Topic: Note for non-jQuery users
//
// jQuery isn't actually required for this plugin, because nothing internal
// uses any jQuery methods or properties. jQuery is just used as a namespace
// under which these methods can exist.
//
// Since jQuery isn't actually required for this plugin, if jQuery doesn't exist
// when this plugin is loaded, the method described below will be created in
// the `Cowboy` namespace. Usage will be exactly the same, but instead of
// $.method() or jQuery.method(), you'll need to use Cowboy.method().

(function (window, undefined) {
  "$:nomunge"; // Used by YUI compressor.

  // Since jQuery really isn't required for this plugin, use `jQuery` as the
  // namespace only if it already exists, otherwise use the `Cowboy` namespace,
  // creating it if necessary.
  var $ = window.jQuery || window.Cowboy || (window.Cowboy = {}),
    // Internal method reference.
    jq_throttle;

  // Method: jQuery.throttle
  //
  // Throttle execution of a function. Especially useful for rate limiting
  // execution of handlers on events like resize and scroll. If you want to
  // rate-limit execution of a function to a single time, see the
  // <jQuery.debounce> method.
  //
  // In this visualization, | is a throttled-function call and X is the actual
  // callback execution:
  //
  // > Throttled with `no_trailing` specified as false or unspecified:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X    X    X    X    X    X        X    X    X    X    X    X
  // >
  // > Throttled with `no_trailing` specified as true:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X    X    X    X    X             X    X    X    X    X
  //
  // Usage:
  //
  // > var throttled = jQuery.throttle( delay, [ no_trailing, ] callback );
  // >
  // > jQuery('selector').bind( 'someevent', throttled );
  // > jQuery('selector').unbind( 'someevent', throttled );
  //
  // This also works in jQuery 1.4+:
  //
  // > jQuery('selector').bind( 'someevent', jQuery.throttle( delay, [ no_trailing, ] callback ) );
  // > jQuery('selector').unbind( 'someevent', callback );
  //
  // Arguments:
  //
  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
  //    callbacks, values around 100 or 250 (or even higher) are most useful.
  //  no_trailing - (Boolean) Optional, defaults to false. If no_trailing is
  //    true, callback will only execute every `delay` milliseconds while the
  //    throttled-function is being called. If no_trailing is false or
  //    unspecified, callback will be executed one final time after the last
  //    throttled-function call. (After the throttled-function has not been
  //    called for `delay` milliseconds, the internal counter is reset)
  //  callback - (Function) A function to be executed after delay milliseconds.
  //    The `this` context and all arguments are passed through, as-is, to
  //    `callback` when the throttled-function is executed.
  //
  // Returns:
  //
  //  (Function) A new, throttled, function.

  $.throttle = jq_throttle = function (
    delay,
    no_trailing,
    callback,
    debounce_mode
  ) {
    // After wrapper has stopped being called, this timeout ensures that
    // `callback` is executed at the proper times in `throttle` and `end`
    // debounce modes.
    var timeout_id,
      // Keep track of the last time `callback` was executed.
      last_exec = 0;

    // `no_trailing` defaults to falsy.
    if (typeof no_trailing !== "boolean") {
      debounce_mode = callback;
      callback = no_trailing;
      no_trailing = undefined;
    }

    // The `wrapper` function encapsulates all of the throttling / debouncing
    // functionality and when executed will limit the rate at which `callback`
    // is executed.
    function wrapper() {
      var that = this,
        elapsed = +new Date() - last_exec,
        args = arguments;

      // Execute `callback` and update the `last_exec` timestamp.
      function exec() {
        last_exec = +new Date();
        callback.apply(that, args);
      }

      // If `debounce_mode` is true (at_begin) this is used to clear the flag
      // to allow future `callback` executions.
      function clear() {
        timeout_id = undefined;
      }

      if (debounce_mode && !timeout_id) {
        // Since `wrapper` is being called for the first time and
        // `debounce_mode` is true (at_begin), execute `callback`.
        exec();
      }

      // Clear any existing timeout.
      timeout_id && clearTimeout(timeout_id);

      if (debounce_mode === undefined && elapsed > delay) {
        // In throttle mode, if `delay` time has been exceeded, execute
        // `callback`.
        exec();
      } else if (no_trailing !== true) {
        // In trailing throttle mode, since `delay` time has not been
        // exceeded, schedule `callback` to execute `delay` ms after most
        // recent execution.
        //
        // If `debounce_mode` is true (at_begin), schedule `clear` to execute
        // after `delay` ms.
        //
        // If `debounce_mode` is false (at end), schedule `callback` to
        // execute after `delay` ms.
        timeout_id = setTimeout(
          debounce_mode ? clear : exec,
          debounce_mode === undefined ? delay - elapsed : delay
        );
      }
    }

    // Set the guid of `wrapper` function to the same of original callback, so
    // it can be removed in jQuery 1.4+ .unbind or .die by using the original
    // callback as a reference.
    if ($.guid) {
      wrapper.guid = callback.guid = callback.guid || $.guid++;
    }

    // Return the wrapper function.
    return wrapper;
  };

  // Method: jQuery.debounce
  //
  // Debounce execution of a function. Debouncing, unlike throttling,
  // guarantees that a function is only executed a single time, either at the
  // very beginning of a series of calls, or at the very end. If you want to
  // simply rate-limit execution of a function, see the <jQuery.throttle>
  // method.
  //
  // In this visualization, | is a debounced-function call and X is the actual
  // callback execution:
  //
  // > Debounced with `at_begin` specified as false or unspecified:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // >                          X                                 X
  // >
  // > Debounced with `at_begin` specified as true:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X                                 X
  //
  // Usage:
  //
  // > var debounced = jQuery.debounce( delay, [ at_begin, ] callback );
  // >
  // > jQuery('selector').bind( 'someevent', debounced );
  // > jQuery('selector').unbind( 'someevent', debounced );
  //
  // This also works in jQuery 1.4+:
  //
  // > jQuery('selector').bind( 'someevent', jQuery.debounce( delay, [ at_begin, ] callback ) );
  // > jQuery('selector').unbind( 'someevent', callback );
  //
  // Arguments:
  //
  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
  //    callbacks, values around 100 or 250 (or even higher) are most useful.
  //  at_begin - (Boolean) Optional, defaults to false. If at_begin is false or
  //    unspecified, callback will only be executed `delay` milliseconds after
  //    the last debounced-function call. If at_begin is true, callback will be
  //    executed only at the first debounced-function call. (After the
  //    throttled-function has not been called for `delay` milliseconds, the
  //    internal counter is reset)
  //  callback - (Function) A function to be executed after delay milliseconds.
  //    The `this` context and all arguments are passed through, as-is, to
  //    `callback` when the debounced-function is executed.
  //
  // Returns:
  //
  //  (Function) A new, debounced, function.

  $.debounce = function (delay, at_begin, callback) {
    return callback === undefined
      ? jq_throttle(delay, at_begin, false)
      : jq_throttle(delay, callback, at_begin !== false);
  };
})(this);

isYoutubeAPILoaded = false;

function loadYoutubeAPI() {
  if (isYoutubeAPILoaded) {
    return;
  } else {
    // Load Youtube API script
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
}

function onYouTubeIframeAPIReady() {
  isYoutubeAPILoaded = true;
  $("body").trigger("youtubeAPIReady");
}
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function (o) {
  var t = {
    url: !1,
    callback: !1,
    target: !1,
    duration: 120,
    on: "mouseover",
    touch: !0,
    onZoomIn: !1,
    onZoomOut: !1,
    magnify: 1,
  };
  (o.zoom = function (t, n, e, i) {
    var u,
      c,
      a,
      r,
      m,
      l,
      s,
      f = o(t),
      h = f.css("position"),
      d = o(n);
    return (
      (t.style.position = /(absolute|fixed)/.test(h) ? h : "relative"),
      (t.style.overflow = "hidden"),
      (e.style.width = e.style.height = ""),
      o(e)
        .addClass("zoomImg")
        .css({
          position: "absolute",
          top: 0,
          left: 0,
          opacity: 0,
          width: e.width * i,
          height: e.height * i,
          border: "none",
          maxWidth: "none",
          maxHeight: "none",
        })
        .appendTo(t),
      {
        init: function () {
          (c = f.outerWidth()),
            (u = f.outerHeight()),
            n === t
              ? ((r = c), (a = u))
              : ((r = d.outerWidth()), (a = d.outerHeight())),
            (m = (e.width - c) / r),
            (l = (e.height - u) / a),
            (s = d.offset());
        },
        move: function (o) {
          var t = o.pageX - s.left,
            n = o.pageY - s.top;
          (n = Math.max(Math.min(n, a), 0)),
            (t = Math.max(Math.min(t, r), 0)),
            (e.style.left = t * -m + "px"),
            (e.style.top = n * -l + "px");
        },
      }
    );
  }),
    (o.fn.zoom = function (n) {
      return this.each(function () {
        var e = o.extend({}, t, n || {}),
          i = (e.target && o(e.target)[0]) || this,
          u = this,
          c = o(u),
          a = document.createElement("img"),
          r = o(a),
          m = "mousemove.zoom",
          l = !1,
          s = !1;
        if (!e.url) {
          var f = u.querySelector("img");
          if (
            (f && (e.url = f.getAttribute("data-src") || f.currentSrc || f.src),
            !e.url)
          )
            return;
        }
        c.one(
          "zoom.destroy",
          function (o, t) {
            c.off(".zoom"),
              (i.style.position = o),
              (i.style.overflow = t),
              (a.onload = null),
              r.remove();
          }.bind(this, i.style.position, i.style.overflow)
        ),
          (a.onload = function () {
            function t(t) {
              f.init(),
                f.move(t),
                r
                  .stop()
                  .fadeTo(
                    o.support.opacity ? e.duration : 0,
                    1,
                    o.isFunction(e.onZoomIn) ? e.onZoomIn.call(a) : !1
                  );
            }
            function n() {
              r.stop().fadeTo(
                e.duration,
                0,
                o.isFunction(e.onZoomOut) ? e.onZoomOut.call(a) : !1
              );
            }
            var f = o.zoom(i, u, a, e.magnify);
            "grab" === e.on
              ? c.on("mousedown.zoom", function (e) {
                  1 === e.which &&
                    (o(document).one("mouseup.zoom", function () {
                      n(), o(document).off(m, f.move);
                    }),
                    t(e),
                    o(document).on(m, f.move),
                    e.preventDefault());
                })
              : "click" === e.on
              ? c.on("click.zoom", function (e) {
                  return l
                    ? void 0
                    : ((l = !0),
                      t(e),
                      o(document).on(m, f.move),
                      o(document).one("click.zoom", function () {
                        n(), (l = !1), o(document).off(m, f.move);
                      }),
                      !1);
                })
              : "toggle" === e.on
              ? c.on("click.zoom", function (o) {
                  l ? n() : t(o), (l = !l);
                })
              : "mouseover" === e.on &&
                (f.init(),
                c
                  .on("mouseenter.zoom", t)
                  .on("mouseleave.zoom", n)
                  .on(m, f.move)),
              e.touch &&
                c
                  .on("touchstart.zoom", function (o) {
                    o.preventDefault(),
                      s
                        ? ((s = !1), n())
                        : ((s = !0),
                          t(
                            o.originalEvent.touches[0] ||
                              o.originalEvent.changedTouches[0]
                          ));
                  })
                  .on("touchmove.zoom", function (o) {
                    o.preventDefault(),
                      f.move(
                        o.originalEvent.touches[0] ||
                          o.originalEvent.changedTouches[0]
                      );
                  })
                  .on("touchend.zoom", function (o) {
                    o.preventDefault(), s && ((s = !1), n());
                  }),
              o.isFunction(e.callback) && e.callback.call(a);
          }),
          a.setAttribute("role", "presentation"),
          (a.alt = ""),
          (a.src = e.url);
      });
    }),
    (o.fn.zoom.defaults = t);
})(window.jQuery);

/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2012 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

if (typeof Shopify.Cart === "undefined") {
  Shopify.Cart = {};
}




/*!
 * enquire.js v2.1.6 - Awesome Media Queries in JavaScript
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT */

!(function (a) {
  if ("object" == typeof exports && "undefined" != typeof module)
    module.exports = a();
  else if ("function" == typeof define && define.amd) define([], a);
  else {
    var b;
    (b =
      "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : this),
      (b.enquire = a());
  }
})(function () {
  return (function a(b, c, d) {
    function e(g, h) {
      if (!c[g]) {
        if (!b[g]) {
          var i = "function" == typeof require && require;
          if (!h && i) return i(g, !0);
          if (f) return f(g, !0);
          var j = new Error("Cannot find module '" + g + "'");
          throw ((j.code = "MODULE_NOT_FOUND"), j);
        }
        var k = (c[g] = { exports: {} });
        b[g][0].call(
          k.exports,
          function (a) {
            var c = b[g][1][a];
            return e(c ? c : a);
          },
          k,
          k.exports,
          a,
          b,
          c,
          d
        );
      }
      return c[g].exports;
    }
    for (
      var f = "function" == typeof require && require, g = 0;
      g < d.length;
      g++
    )
      e(d[g]);
    return e;
  })(
    {
      1: [
        function (a, b, c) {
          function d(a, b) {
            (this.query = a),
              (this.isUnconditional = b),
              (this.handlers = []),
              (this.mql = window.matchMedia(a));
            var c = this;
            (this.listener = function (a) {
              (c.mql = a.currentTarget || a), c.assess();
            }),
              this.mql.addListener(this.listener);
          }
          var e = a(3),
            f = a(4).each;
          (d.prototype = {
            constuctor: d,
            addHandler: function (a) {
              var b = new e(a);
              this.handlers.push(b), this.matches() && b.on();
            },
            removeHandler: function (a) {
              var b = this.handlers;
              f(b, function (c, d) {
                if (c.equals(a)) return c.destroy(), !b.splice(d, 1);
              });
            },
            matches: function () {
              return this.mql.matches || this.isUnconditional;
            },
            clear: function () {
              f(this.handlers, function (a) {
                a.destroy();
              }),
                this.mql.removeListener(this.listener),
                (this.handlers.length = 0);
            },
            assess: function () {
              var a = this.matches() ? "on" : "off";
              f(this.handlers, function (b) {
                b[a]();
              });
            },
          }),
            (b.exports = d);
        },
        { 3: 3, 4: 4 },
      ],
      2: [
        function (a, b, c) {
          function d() {
            if (!window.matchMedia)
              throw new Error(
                "matchMedia not present, legacy browsers require a polyfill"
              );
            (this.queries = {}),
              (this.browserIsIncapable =
                !window.matchMedia("only all").matches);
          }
          var e = a(1),
            f = a(4),
            g = f.each,
            h = f.isFunction,
            i = f.isArray;
          (d.prototype = {
            constructor: d,
            register: function (a, b, c) {
              var d = this.queries,
                f = c && this.browserIsIncapable;
              return (
                d[a] || (d[a] = new e(a, f)),
                h(b) && (b = { match: b }),
                i(b) || (b = [b]),
                g(b, function (b) {
                  h(b) && (b = { match: b }), d[a].addHandler(b);
                }),
                this
              );
            },
            unregister: function (a, b) {
              var c = this.queries[a];
              return (
                c &&
                  (b
                    ? c.removeHandler(b)
                    : (c.clear(), delete this.queries[a])),
                this
              );
            },
          }),
            (b.exports = d);
        },
        { 1: 1, 4: 4 },
      ],
      3: [
        function (a, b, c) {
          function d(a) {
            (this.options = a), !a.deferSetup && this.setup();
          }
          (d.prototype = {
            constructor: d,
            setup: function () {
              this.options.setup && this.options.setup(),
                (this.initialised = !0);
            },
            on: function () {
              !this.initialised && this.setup(),
                this.options.match && this.options.match();
            },
            off: function () {
              this.options.unmatch && this.options.unmatch();
            },
            destroy: function () {
              this.options.destroy ? this.options.destroy() : this.off();
            },
            equals: function (a) {
              return this.options === a || this.options.match === a;
            },
          }),
            (b.exports = d);
        },
        {},
      ],
      4: [
        function (a, b, c) {
          function d(a, b) {
            var c = 0,
              d = a.length;
            for (c; c < d && b(a[c], c) !== !1; c++);
          }
          function e(a) {
            return "[object Array]" === Object.prototype.toString.apply(a);
          }
          function f(a) {
            return "function" == typeof a;
          }
          b.exports = { isFunction: f, isArray: e, each: d };
        },
        {},
      ],
      5: [
        function (a, b, c) {
          var d = a(2);
          b.exports = new d();
        },
        { 2: 2 },
      ],
    },
    {},
    [5]
  )(5);
});


theme.ColorSwatches = {
  bind: function () {
    $(".product-form").on("change", ".swatch :radio", function () {
      var optionIndex = $(this).closest(".swatch").attr("data-option-index");
      var optionValue = $(this).val();
      var selector = "[data-single-option-selector]";

      $(this)
        .closest("form")
        .find(selector)
        .eq(optionIndex)
        .val(optionValue)
        .trigger("change");
    });
  },
  unbind: function () {
    $(".product-form").off("change", ".swatch :radio");
  },
  destroy: function () {
    this.unbind();

    $(".product-form").find(".swatch, style").remove();
  },
};


theme.TouchDetect = (function () {
  var touchDevice = false;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
  };
})();

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;
    // Looked up by id: a hash is not always a valid selector (#!/path), and
    // jQuery throws on one that is not.
    var target = hash && document.getElementById(hash.slice(1));

    if (target) {
      this.pageLinkFocus($(target));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === "undefined"
        ? ""
        : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === "undefined"
        ? ""
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:section:reorder", this._onReorder.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructors) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructors = constructors || this.constructors[type];

    if (typeof constructors === "undefined") {
      return;
    }

    for (var i = 0; i < constructors.length; i++) {
      var constructor = constructors[i];
      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container,
      });
      this.instances.push(instance);
    }
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.originalEvent.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === "function") {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      "id",
      evt.originalEvent.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.originalEvent.detail.sectionId
    );

    if (instance && typeof instance.onSelect === "function") {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.originalEvent.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.originalEvent.detail.sectionId
    );

    if (instance && typeof instance.onReorder === "function") {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.originalEvent.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.originalEvent.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructors) {
    if (!Array.isArray(constructors)) {
      constructors = [constructors];
    }

    this.constructors[type] = constructors;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        // A section script runs once per section that includes it (hero.js
        // three times on the homepage), so the same type can be registered
        // again; each container is built once. Matched by element, not id:
        // the blocks of one section can share its id.
        if (slate.utils.findInstance(this.instances, "container", container)) {
          return;
        }
        this._createInstance(container, constructors);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = "${{amount}}";

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ",");
      decimal = slate.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    //disable historyState
    this.enableHistoryState = false;

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/*================ Features ================*/
window.isYoutubeAPILoaded = false;
function loadYoutubeAPI() {
  if (window.isYoutubeAPILoaded) {
    return;
  } else {
    // Load Youtube API script
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
}
function onYouTubeIframeAPIReady() {
  window.isYoutubeAPILoaded = true;
  $("body").trigger("youtubeAPIReady");
}

window.isPlyrLoaded = false;
function loadPlyr() {
  if (window.isPlyrLoaded) {
    return;
  } else {
    // Load Youtube API script
    try {
      window.Shopify.loadFeatures(
        [
          {
            name: "video-ui",
            version: "1.0",
            onLoad: handleShopifyXRLoadError,
          },
        ],
        plyrLoaded
      );
    } catch (error) {
      console.log("An error occured while loading the Shopify Video interface");
      throw error;
    }
  }
}
function plyrLoaded() {
  window.isPlyrLoaded = true;
  $("body").trigger("plyrReady");
}

function handleShopifyXRLoadError(error) {
  if (error) {
    throw error;
  }
}

theme.ProductModel = (function () {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};
  var selectors = {
    productMediaWrapper: "[data-product-single-media-wrapper]",
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false,
    };

    modelViewerContainers.each(function (index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data("media-id");
      var $modelViewerElement = $(
        $modelViewerContainer.find("model-viewer")[0]
      );

      var modelId = $modelViewerElement.data("model-id");

      if (index === 0) {
        var $xrButton = $modelViewerContainer
          .closest("[data-product-slideshow]")
          .find("[data-shopify-xr]");
        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId,
        };
      }

      models[mediaId] = {
        modelId: modelId,
        mediaId: mediaId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement,
      };
    });

    window.Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: setupShopifyXr,
      },
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: setupModelViewerUi,
      },
    ]);
  }

  function setupShopifyXr(errors) {
    if (errors) {
      console.warn(errors);
      return;
    }
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", function () {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];
        if (modelSection.loaded) continue;

        var $modelJson = $("#ModelJson-" + sectionId);
        if ($modelJson.length) {
          window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
          modelSection.loaded = true;
        }
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) {
      console.warn(errors);
      return;
    }

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];

    model.$container
      .on("mediaVisible", function () {
        xrButton.$element.attr("data-shopify-model3d-id", model.modelId);

        pauseOtherMedia(model.mediaId);

        if (theme.TouchDetect.isTouch()) return;
        model.modelViewerUi.play();
      })
      .on("mediaHidden", function () {
        xrButton.$element.attr("data-shopify-model3d-id", xrButton.defaultId);
        model.modelViewerUi.pause();
      })
      .on("xrLaunch", function () {
        model.modelViewerUi.pause();
      });

    model.$element.on("shopify_model_viewer_ui_toggle_play", function () {
      pauseOtherMedia(model.mediaId);
    });
  }

  function pauseOtherMedia(mediaId) {
    var $currentMedia = $(
        "[data-product-single-media-wrapper]" +
          '[data-media-id="' +
          mediaId +
          '"]'
      ),
      $otherMedia = $("[data-product-single-media-wrapper]").not($currentMedia);

    $currentMedia.removeClass("media--hidden");
    $otherMedia.trigger("mediaHidden").addClass("media--hidden");
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
    delete theme.mediaInstances[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels,
  };
})();


/*================ Sections ================*/
/**
 * Header Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Header template.
 *
 * @namespace product
 */

theme.Header = (function () {
  /**
   * Header section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Header(container) {
    this.$container = $(container);
    mainNavigation();
    initSearch();
    headerPush();

    var hasVideo = false;

    //put negative margin on body if header is transparent
    /*
    if ($("body").hasClass("body-header-transparent"))
      $("#MainContent").css(
        "margin-top",
        $("header.site-header").outerHeight() * -1
      );
    */
    if ($("#header").hasClass("header--sticky")) {
      stickyHeader();
      $("#header").scrollToFixed({
        spacerClass: "header-fixed-header-spacer",
      });
    }

    $(window).on("resize", $.debounce(100, headerPush)).on("load", headerPush);
  }

  function mainNavigation() {
    // Dropdown Menus
    $("#MainNav li.has-sub-nav").on("click", function (e) {
      e.preventDefaut();

      var submenu = $(this).children(".submenu");
      var isThirdLevel = submenu.hasClass("submenu--third-level");

      if (isThirdLevel) {
        setSubmenuPosition(submenu);
      }

      checkAriaStatus(submenu);

      submenu.toggleClass("open");
    });

    /*

    $('#MainNav li.has-sub-nav').on('mouseleave', function(e) {
      $(this).children('.submenu').removeClass('open');

      var submenu = $(this).children('.submenu');
      checkAriaStatus(submenu);
    });
    
    */

    function closeMenu() {
      var _fmPrevFocus = document.activeElement;

      $("#NavMenus").toggleClass("active");
      $("html, body").toggleClass("mobile-menu--open");
      $(".toggle-menus").toggleClass("toggle-menus--open");
      
      if($(".toggle-menus").hasClass('toggle-menus--open')){
        theme.ChatWidget.hide();
      }else{
        theme.ChatWidget.show();
      }

      // submenus shouldn't be visible
      $("#NavMenus .submenu").removeClass("active");
      $(".has-sub-nav").removeClass("open");
      $(".header-content .toggle-menus").show();

      //show custom menu
      $("#fixed-menu").toggleClass("active");

      //hide fixed sub menu
      $("#fixed-menu").removeClass("submenu-open");
      $(".fixed-nav-menu-item.active").removeClass("active");
      // An opted-in sub panel (assets/header.js) also drops its inert, hidden and expanded state.
      if (typeof drawerPanelReset === "function") drawerPanelReset();

      // hide search
      $("#SearchToggle, .search").removeClass("search--open");
      $('body,html').removeClass('body-search--open');
      $("#header-wrapper-custom").removeClass("search-active");

      $(".fixed-menu-container").removeClass("closing");

      // A11y: on OPEN move focus into the top of the dialog; on CLOSE restore focus to the trigger.
      if ($("#fixed-menu").hasClass("active")) {
        window._fixedMenuTrigger = _fmPrevFocus;
        window._fixedMenuOpen = true;
        setTimeout(function () {
          $("#fixed-menu").focus();
        }, 0);
      } else if (window._fixedMenuOpen) {
        window._fixedMenuOpen = false;
        if (window._fixedMenuTrigger && window._fixedMenuTrigger.focus) {
          window._fixedMenuTrigger.focus();
        }
      }
    }

    function openNav($list) {
      $list.find("li").each(function (i) {
        $(this)
          .delay(100 * i)
          .queue(function () {
            $(this).addClass("show").dequeue();
          });
      });
    }

    function closeNav($list) {
      $list.find("li").each(function (i) {
        $(this)
          .delay(100 * i)
          .queue(function () {
            $(this).removeClass("show").dequeue();
            if ($(this).hasClass("last")) {
              var delay = 400;
              $(".fixed-menu-container").addClass("closing");
              setTimeout(function () {
                closeMenu();
              }, delay);
            }
          });
      });
    }

    // Close menu on body click
    $(document).on("click", function (e) {
      if (
        !$(e.target).is(".fixed-menu-left *") &&
        !$(e.target).is(".toggle-menus *") &&
        !$(e.target).is(".toggle-menus") &&
        !$(e.target).is(".js-toggle-menus *") &&
        !$(e.target).is(".js-toggle-menus") &&
        $("html").hasClass("mobile-menu--open")
      ) {
        /*
        var $nav_menu = $('ul[data-anchor="main"]');
        var delay = 400;
        $(".fixed-menu-container").addClass("closing");
        setTimeout(function () {
          closeMenu();
        }, delay);
        */
        closeMenu();
      }
    });

    // Mobile/responsive menu
    $(".toggle-menus, .js-fixed-nav-close, .js-toggle-menus").on(
      "click",
      $.throttle(500, function (e) {
        e.preventDefault();
        var $nav_menu = $('ul[data-anchor="main"]');
        closeMenu();
        /*
        if ($("#fixed-menu").hasClass("active")) {
          var delay = 400;
          $(".fixed-menu-container").addClass("closing");
          setTimeout(function () {
            closeMenu();
          }, delay);

          //closeNav($nav_menu);
        } else {
          closeMenu();
          //openNav($nav_menu);
        }
        */
      })
    );

    // A11y: Escape closes the mobile menu dialog; Tab is trapped inside it while open.
    $(document).on("keydown", function (e) {
      if (!$("#fixed-menu").hasClass("active")) return;
      if (e.key === "Escape" || e.keyCode === 27) {
        closeMenu();
        return;
      }
      if (e.key === "Tab" || e.keyCode === 9) {
        var $f = $("#fixed-menu")
          .find("a[href], button, input, select, textarea, [tabindex]")
          .filter(":visible")
          .not("[tabindex='-1']")
          .filter(function () {
            return !this.closest("[inert]");
          });
        if (!$f.length) return;
        var first = $f[0];
        var last = $f[$f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // Dropwodn menus on hover
    $(".has-sub-nav > a").on("click touchstart", function (e) {
      var isMobile = $(window).width() < 750;
      if (isMobile) {
        e.preventDefault();
        $(this)
          .parent()
          .toggleClass("open")
          .children(".submenu")
          .toggleClass("active");
        $(this)
          .parent()
          .find(".has-sub-nav")
          .removeClass("open")
          .find(".submenu")
          .removeClass("active");

        // hide search
        $("#SearchToggle, .search").removeClass("search--open");
        $('body,html').removeClass('body-search--open');
        $("#header-wrapper-custom").removeClass("search-active");

        var submenu = $(this).next();
        checkAriaStatus(submenu);
      }
    });
    /*
    $('.navigation__wrapper .main-menu > li > a.nav-link').focus(function() {
      $(this).parent('li').addClass('active').siblings().removeClass('active')
    }).blur(function(){
      $(this).parent('li').siblings().removeClass('active')
    });
    
	
    $('.navigation__wrapper .main-menu > li > a.nav-link').hover(function() {
      $(this).parent('li').siblings().removeClass('active')
    });
    */

    navStates();
  }

  function checkAriaStatus(submenu) {
    var state = submenu.hasClass("open") || submenu.hasClass("active");

    if (state) {
      submenu.attr("aria-expanded", true);
    } else {
      submenu.attr("aria-expanded", false);
    }
  }

  function setSubmenuPosition(submenu) {
    var parentOffsetLeft = submenu.parent().offset().left;
    var windowCenter = $(window).width() / 2;
    var offsetLeft = windowCenter - parentOffsetLeft;

    submenu.css("left", offsetLeft);
  }

  // Nav Active States
  function navStates() {
    var links = $("#MainNav .has-sub-nav > a"),
      sub_links = $("#MainNav .has-sub-nav .submenu > li > a");

    links.each(function () {
      var href = $(this).attr("href"),
        location = window.location.pathname;

      if (href === location) {
        $(this).closest(".has-sub-nav").addClass("active");
      }
    });

    sub_links.each(function () {
      var href = $(this).attr("href"),
        location = window.location.pathname;

      if (href === location) {
        $(this).addClass("active");
        $(this).closest("li").addClass("active");
        $(this).closest(".has-sub-nav").addClass("active");
      }
    });

    $(".grandparent-link").click(function (e) {
      if ($(window).width() > 768) {
        e.preventDefault();
      }
    });

    $(".grandparent").click(function (e) {
      console.log(e);
      if ($(this).hasClass("active")) {
        $("#header").removeClass("meganav--visible");
        $("#header .main-menu .grandparent.active").removeClass("active");
        $(this).removeClass("active");
      } else {
        $("#header").addClass("meganav--visible");
        $("#header .main-menu .grandparent.active").removeClass("active");
        $(this).addClass("active");
      }
    });
  }

  function initSearch() {
    $("#SearchToggle").on(
      "click",
      $.throttle(500, function () {
        $("#SearchToggle, .search").toggleClass("search--open");
        $('body,html').toggleClass('body-search--open');
        $("#header-wrapper-custom").toggleClass("search-active");
        $("#SearchToggle").attr("aria-expanded", $("#SearchToggle").hasClass("search--open"));
        // hide mobile menu
        $(".toggle-menus").removeClass("toggle-menus--open");
        $("#NavMenus, .has-sub-nav ul.submenu").removeClass("active");
        $(".has-sub-nav").removeClass("open");
        $("#header .search-query").select();

        //hide Chat Widget
        theme.ChatWidget.hide();
      })
    );

    // Hide search
    $(".remove-search").on("click", function () {
      $("#SearchToggle, .search").removeClass("search--open");
      $('body,html').removeClass('body-search--open');
      $("#header-wrapper-custom").removeClass("search-active");
      // A11y: reflect collapsed state and return focus to the search trigger.
      $("#SearchToggle").attr("aria-expanded", "false").focus();

      //show Chat Widget
      theme.ChatWidget.show();
    });

    // A11y: links that act as buttons (<a role="button">) activate on Space as well as
    // Enter, like a native button. Enter already clicks a link. Controls with their own
    // Space handler must act on keydown and call preventDefault (element handlers run
    // before this delegated one), so they are skipped here and never fire twice.
    $(document)
      .off("keydown.a11yButtonLink")
      .on("keydown.a11yButtonLink", 'a[role="button"]', function (e) {
        if ((e.key === " " || e.keyCode === 32) && !e.isDefaultPrevented()) {
          e.preventDefault();
          this.click();
        }
      });

    $("body").bind("click", function (e) {
      var $target = $(e.target);
      if (
        !$target.hasClass("search-query") &&
        !$target.is("#SearchToggle") &&
        !$target.is("#SearchToggle span") &&
        !$target.is('.js-popular-search-item') &&
        $(".search").hasClass("search--open")
      ) {
        $("#SearchToggle, .search").removeClass("search--open");
        $("#header-wrapper-custom").removeClass("search-active");
        $('body,html').removeClass('body-search--open');
        $("#SearchToggle").attr("aria-expanded", "false");

        // A11y: return focus to the search trigger only if focus would otherwise be
        // stranded on the now-hidden search; if the click moved focus to another
        // control, leave it there.
        var _ae = document.activeElement;
        if (!_ae || _ae === document.body || $(_ae).closest(".search").length > 0) {
          $("#SearchToggle").focus();
        }

        //show Chat Widget
        theme.ChatWidget.show();
      }
    });

    // A11y: close the whole search overlay once focus leaves it entirely (e.g. tabbing
    // past the last field), so keyboard users aren't left with an open, unfocused search.
    $(".header-search-form").on("focusout", function () {
      var form = this;
      setTimeout(function () {
        if (
          $(window).width() > 768 &&
          $(".search").hasClass("search--open") &&
          document.activeElement &&
          document.activeElement !== document.body &&
          !form.contains(document.activeElement)
        ) {
          $("#SearchToggle, .search").removeClass("search--open");
          $("#header-wrapper-custom").removeClass("search-active");
          $('body,html').removeClass('body-search--open');
          $("#SearchToggle").attr("aria-expanded", "false");
          theme.ChatWidget.show();
        }
      }, 0);
    });

    // A11y: Escape closes the search overlay and returns focus to the search trigger,
    // matching the cart drawer and mobile menu dialog behavior. Namespaced + rebound
    // idempotently so re-init never stacks duplicate handlers.
    $(document).off("keydown.search").on("keydown.search", function (e) {
      if (
        (e.key === "Escape" || e.keyCode === 27) &&
        $(".search").hasClass("search--open")
      ) {
        $("#SearchToggle, .search").removeClass("search--open");
        $("#header-wrapper-custom").removeClass("search-active");
        $('body,html').removeClass('body-search--open');
        $("#SearchToggle").attr("aria-expanded", "false").focus();
        theme.ChatWidget.show();
      }
    });
  }

  // Push down the content as much as the height of the header
  function headerPush() {
    var $header = $("#header"),
      $headerContent = $header.find(".header__content"),
      $main = $("#MainContent"),
      $nav = $("#NavMenus"),
      headerHeight = $headerContent.outerHeight(),
      isHeaderTransparent = $header.data("overlay"),
      isMobile = $(window).width() < 750,
      hasVideo = false,
      isBlackTheme = false;

    if ($("#template-product.has-video").length > 0) hasVideo = true;
    if ($("#template-product.has-video.black").length > 0) isBlackTheme = true;

    // Remove transparent header styles if there's no collection image
    if (isHeaderTransparent) {
      let isCollectionTemplate = $("body").hasClass("template-collection");
      let hasFeaturedImage = $(".collection__image").length;

      // No transparent header if collection page has no featured image
      if (isCollectionTemplate && !hasFeaturedImage) {
        $header.attr("data-overlay", "false");
        $main.css("padding-top", headerHeight);
        isHeaderTransparent = false;
      }
    }
  }

  // Sticky header
  function stickyHeader() {
    var $header = $("#header");
    var $headerContent = $header.find(".header__content");
    var isSticky = $header.hasClass("header--sticky");
    var headerHeight = $headerContent.outerHeight();

    setHeaderState(true);
    $(window)
      .on(
        "scroll",
        $.debounce(5, function () {
          setHeaderState(false);
        })
      )
      .on("load", setHeaderState(true));

    function setHeaderIsSticky(firstTimeLoad = false) {
      var scrolled = $(window).scrollTop();
      var topBarHeight = $(".promotion-slider-section").outerHeight();
      var $buyNowWrapper = $(".product-buy-now-wrapper");
      var $headerPromotion = $(".promotion-slider-wrapper");
      var $body = $("body");

      if (topBarHeight) {
        if (scrolled > 0) {
          $body.addClass("header-is-sticky");
          $header.addClass("is-sticky");
        } else if ($body.hasClass("scrolling-up")) {
          if (!firstTimeLoad && !$body.hasClass("animatingS")) {
            $body.removeClass("header-is-sticky");
            $header.removeClass("is-sticky");
            $body.addClass("animatingS");
            setTimeout(function () {
              $body.removeClass("animatingS");
            }, 300);
          }
        }
      } else {
        if (scrolled > 0) {
          $header.addClass("is-sticky");
          $body.addClass("header-is-sticky");
        } else if ($body.hasClass("scrolling-up")) {
          if (!firstTimeLoad && !$body.hasClass("animatingS")) {
            $body.removeClass("header-is-sticky");
            $header.removeClass("is-sticky");
            $body.addClass("animatingS");
            setTimeout(function () {
              $body.removeClass("animatingS");
            }, 300);
          }
        }
      }
    }

    function setHeaderState(firstTimeLoad = false) {
      var $buyNowWrapper = $(".product-buy-now-wrapper");

      //wait for buy now bar animation to finish
      if ($buyNowWrapper.length > 0 && $buyNowWrapper.hasClass("animatingS")) {
        setTimeout(function () {
          setHeaderIsSticky(firstTimeLoad);
        }, 200);
      } else {
        setHeaderIsSticky(firstTimeLoad);
      }
    }
  }

  return Header;
})();


/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.variables = {
  productPageSticky: false,
  bpSmall: false,
  mediaQueryMediumUp: "screen and (min-width: 750px)",
  mediaQuerySmall: "screen and (max-width: 749px)",
};

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.variables = {
  productPageSticky: false,
  bpSmall: false,
  mediaQueryMediumUp: "screen and (min-width: 750px)",
  mediaQuerySmall: "screen and (max-width: 749px)",
};

theme.ProductGrid = (function () {

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function ProductGrid(container) {
    var self = this;

  }

  ProductGrid.prototype = $.extend({}, ProductGrid.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
  });

  return ProductGrid;
})();






theme.Overflow = (function () {
  function Overflow(container) {
    this.init();
  }
  Overflow.prototype = $.extend({}, Overflow.prototype, {
    init: function () {
      theme.preventOverflow();
    },
  });
  return Overflow;
})();

theme.$body = $("body");
theme.bodyHeight = theme.$body.height();

theme.Footer = (function () {
  function Footer(container) {
    var $container = (this.$container = $(container));
    var id = (this.id = $container.attr("data-section-id"));
    var $featuredImage = (this.$featuredImage = $("#FeaturedImage-" + id));
    var featuredImageSelector = (this.featuredImageSelector =
      "#FeaturedImage-" + id);
    var parallaxSliderSelector = (this.parallaxSliderSelector =
      "#FeaturedImage-" + id + " .parallax-slider");

    var parallaxImageSelector = (this.parallaxImageSelector = "#FeaturedImage-" + id + " .footer-background-image");


    stickyFooter();
    $(window).resize(function () {
      stickyFooter();
    });
    this.init();
  }

  function stickyFooter() {
    var $siteContainer = $("#SiteContainer");
    $siteContainer.css(
      "min-height",
      $(window).height() - $("#Footer").height()
    );
  }

  Footer.prototype = $.extend({}, Footer.prototype, {
    init: function () {
    

      function watchBodyHeight() {
        if (theme.bodyHeight != theme.$body.height()) {
          $(window).resize();
          theme.bodyHeight = theme.$body.height();
        }
        setTimeout(watchBodyHeight, 3000);
      }
      watchBodyHeight();
    }
  });

  return Footer;
})();

/**
 * Cart functions
 * ------------------------------------------------------------------------------
 * Functions that should execute everywhere
 *
 */

theme.Cart = (function () {
  function Cart(container) {
    this.init();
  }
  Cart.prototype = $.extend({}, Cart.prototype, {
    init: function () {
      // Setup listeners to add/subtract from the input
      $(".js-qty__adjust").on("click", function () {
        var el = $(this),
          qtySelector = el.siblings(".js-qty__num"),
          qty = parseInt(qtySelector.val().replace(/\D/g, ""));

        // Make sure we have a valid integer
        if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
          // We have a number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        // Add or subtract from the current quantity
        if (el.hasClass("js-qty__adjust--plus")) {
          qty = qty + 1;
        } else {
          qty = qty - 1;
        }
        // Update the input's number
        qtySelector.val(qty).trigger("change");
      });

      $(".show-calculator").on("click", function () {
        $("#ShippingCalculator").slideToggle();
        $(this).toggleClass("open");
      });
      $(".show-note").on("click", function () {
        $("#NoteForSeller").slideToggle();
        $(this).toggleClass("open");
      });

      Shopify.Cart.ShippingCalculator.show({
        submitButton: theme.strings.shippingCalcSubmitButton,
        submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
        customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
        moneyFormat: theme.strings.shippingCalcMoneyFormat,
      });

      $(".template-cart")
        .on("change", ".js-qty__num", function (e) {
          var $this = $(this),
            $form = $this.closest("form.cart");

          $this
            .prop("disabled", true)
            .parents(".js-qty")
            .addClass("qty--disabled")
            .end()
            .siblings()
            .prop("disabled", true);

          var $cart = $(".cart");
          var qty = $this.val();
          var id = $this.attr("id");
          var product_id = id.substring(parseInt(id.indexOf("_") + 1));
          var moneyFormat = window.monies;

          $.ajax({
            type: "post",
            url: "/cart/change.js",
            dataType: "json",
            data: {
              quantity: qty,
              id: product_id,
            },
            success: function (data) {
              // Set the updated line item new price
              for (var i = 0; i < data.items.length; i++) {
                var currentItem = data.items[i];
                var $lineItem = $cart.find(
                  '.item[data-variant-id="' + currentItem.variant_id + '"]'
                );

                $lineItem
                  .find(".js-qty__num")
                  .prop("value", currentItem.quantity);
                $lineItem
                  .find(".total")
                  .html(
                    Shopify.formatMoney(currentItem.line_price, moneyFormat)
                  );
              }

              // Set the new total price
              $cart
                .find(".cart__subtotal")
                .html(Shopify.formatMoney(data.total_price, moneyFormat));

              // Update cart total
              updateCartTotal();

              $this
                .prop("disabled", false)
                .parents(".js-qty")
                .removeClass("qty--disabled")
                .end()
                .siblings()
                .prop("disabled", false);
            },
          });

          // remove line item if the quantity is 0
          if (qty == 0) {
            $this.closest(".item").fadeOut(function () {
              $this.remove();
              updateCartTotal();
            });
          }

          function updateCartTotal() {
            $.getJSON("/cart.js", function (cart) {
              $(".cart-count-js").html(cart.item_count);
            });
          }
        })
        .on("click", ".remove", function (e) {
          e.preventDefault();
          $(this)
            .closest(".item")
            .find(".js-qty__num")
            .prop("value", 0)
            .change();
        });
    },
  });
  return Cart;
})();

/*================ Templates ================*/
/**
 * Global functions
 * ------------------------------------------------------------------------------
 * Functions that should execute everywhere
 *
 */

/**
 * If the element has ariaToggle then toggle the expanded class for whatever ID is set in aria-controls
 */
theme.ariaToggle = function () {
  $(document).on("click", ".ariaToggle", function (event) {
    event.preventDefault();
    console.log("aria");
    if ($(this).parent().hasClass("grandparent")) {
      $(this)
        .siblings(".main-menu-dropdown")
        .find(".ariaToggle")
        .trigger("click");
    }
    var $currentTarget = $(event.currentTarget);
    $currentTarget.attr(
      "aria-expanded",
      $currentTarget.attr("aria-expanded") == "false" ? "true" : "false"
    );
    var toggleID = $currentTarget.attr("aria-controls");
    $("#" + toggleID).toggleClass("expanded");
  });
};

theme.floatLabels = function () {
  $(function () {
    $("input, textarea")
      .on("checkval", function () {
        var label = $(this).prev("label");
        if (this.value !== "") {
          label.addClass("label--float ");
        } else {
          label.removeClass("label--float ");
        }
      })
      .on("keyup", function () {
        $(this).trigger("checkval");
      });
    $("input, textarea").val(function (index, value) {
      if (value.length) {
        var label = $(this).prev("label");
        label.addClass("label--float ");
      }
      return value;
    });
  });
};

// Run smooth scroll on same-page anchors
theme.smoothScroll = function () {
  $('a[href*="#"]:not([href="#"])').click(function (event) {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        event.preventDefault();
        $("html, body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000
        );
      }
    }
  });
};

(theme.preventOverflow = function () {
  $(".js-overflow-container").css("min-height", function () {
    return $(this).find(".js-overflow-content").outerHeight(true);
  });
}),
  (theme.lazyImageBackgrounds = function () {
    document.addEventListener("lazyloaded", function (e) {
      $(e.target).parent(".lazy-image").css("background-image", "none");
    });
  });

theme.fullHeight = function () {
  //doesnt apply if header is transparent
  if ($("body").hasClass("body-header-transparent")) return;

  /*
  var windowHeight = $(window).height();
  var navHeight = $(".header__wrapper").height();
  var heroHeight = windowHeight - navHeight;
  $(".index-sections > .shopify-section:first-child > .screen-height-full")
    .height(heroHeight)
    .css("min-height", "initial");
  $(
    ".index-sections > .shopify-section:first-child > .screen-height-full.homepage-slideshow .slideshow__slide"
  ).height(heroHeight);
  */
};

theme.setBreakpoints = function () {
  enquire.register(theme.variables.mediaQuerySmall, {
    match: function () {
      theme.variables.bpSmall = true;
    },
    unmatch: function () {
      theme.variables.bpSmall = false;
    },
  });
};

theme.quantitySelectors = function () {
  // Setup listeners to add/subtract from the input
  $(".js-qty__adjust").on("click", function () {
    var el = $(this),
      qtySelector = el.siblings(".js-qty__num"),
      qty = parseInt(qtySelector.val().replace(/\D/g, ""));

    // Make sure we have a valid integer
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    // Add or subtract from the current quantity
    if (el.hasClass("js-qty__adjust--plus")) {
      qty = qty + 1;
    } else {
      qty = qty - 1;
      if (qty <= 1) qty = 1;
    }
    // Update the input's number
    qtySelector.val(qty).trigger("change");
  });
};

theme.detectIframe = function () {
  if (window.self !== window.top) {
    $("html").addClass("iframe");
  }
};

theme.init = function () {
  theme.floatLabels();
  theme.detectIframe();
  theme.lazyImageBackgrounds();
  theme.setBreakpoints();
  theme.fullHeight();
  theme.ariaToggle();
  theme.smoothScroll();
  theme.preventOverflow();
};

$(theme.init);



/**
 * Account page functions
 * ------------------------------------------------------------------------------
 * Functions that should execute everywhere
 *
 */

theme.Account = function () {
  // Mobile dropdown
  $(".account-sidebar--mobile").on("click", function () {
    $(this).next("ul").toggleClass("visible");
  });
};

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $("#AddressNewForm");

  if (!$newAddressForm.length) {
    return;
  }

  $(document).ready(function () {
    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew",
        }
      );
    }

    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function () {
      var formId = $(this).data("form-id");
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;

      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });
  });

  // Toggle new/edit address forms
  $(".address-new-toggle").on("click", function () {
    $newAddressForm.toggleClass("hide");
  });

  $(".address-edit-toggle").on("click", function () {
    var formId = $(this).data("form-id");
    $("#EditAddress_" + formId).toggleClass("hide");
  });

  $(".address-delete").on("click", function () {
    var $el = $(this);
    var formId = $el.data("form-id");
    var confirmMessage = $el.data("confirm-message");
    if (
      confirm(confirmMessage || "Are you sure you wish to delete this address?")
    ) {
      Shopify.postLink("/account/addresses/" + formId, {
        parameters: { _method: "delete" },
      });
    }
  });
})();

$(document).ready(function () {
  // Exposed before anything below can throw. Sections whose constructor
  // lives in its own file (collection.js, hero.js, slideshow.js,
  // image-with-text.js, featured-video.js, product.js) register from that
  // file's ready callback: jQuery loads deferred and can run this callback
  // before those files have run, and a section type whose file is not on the
  // page (index-video-parallax) then simply has no constructor.
  var sections = (window.sections = new slate.Sections());
  sections.register("header", theme.Header);
  sections.register("featured-products", [theme.ProductGrid]);
  sections.register("search", theme.ProductGrid);
  sections.register("newsletter", theme.Overflow);
  sections.register("footer", theme.Footer);
  sections.register("cart", [theme.Cart, theme.Drawer]);

  // Common a11y fixes
  slate.a11y.focusHash();

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = ".rte table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "rte__table-wrapper",
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "rte__video-wrapper",
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      );
  }

  // Account Page
  if ($(".customer-logged-in .account").length) {
    theme.Account();
  }

  // Animate on scroll
  var showAnimations = $("body").data("animations");
  if (showAnimations && window.AOS) {
    AOS.init({ once: true });
    $("body").addClass("aos-initialized");
  }

  jQuery.ajaxSetup({ cache: false });
});

$(document).one("touchstart", function () {
  theme.TouchDetect.setTouch();
});

/*

$(document).ajaxComplete(function() {
  $(window).resize();
});


*/

//intercom
theme.Intercom = {
  show: function () {
    let intercomContainer = document.querySelector('.intercom-launcher')

    if (!intercomContainer) return;
    
    intercomContainer.style.display = "block"

  },

  hide: function () {
    let intercomContainer = document.querySelector('.intercom-launcher')

    if (!intercomContainer) return;
    
    intercomContainer.style.display = "none"
  }
}

// Gorgias loads on demand: snippets/gorgias-facade.liquid owns the launcher
// (its stand-in until a visitor asks for chat, Gorgias's own after that), so
// every show, hide and open goes through it.
theme.ChatWidget = {
  show: function() {
    if (window.CodeageChat) window.CodeageChat.show();
  },

  hide: function() {
    if (window.CodeageChat) window.CodeageChat.hide();
  },

  open: function() {
    if (window.CodeageChat) window.CodeageChat.open();
  }
}
